<template>
  <v-form>
    <v-row>
      <v-col cols="12" md="6" class="pb-0">
        <gg-select
          label="Type of Redirect"
          name="Type"
          :items="redirects"
          v-model="model.type"
          v-validate="'required'"
          :error-messages="errors.collect('Type')"
        />
      </v-col>
      <v-col cols="12" md="6" class="pb-0">
        <gg-input-label>Select Domain</gg-input-label>
        <domain-select
          all-domains
          class="gg-input"
          no-label
          outlined
          dense
          :remote_domain="model.domain"
          v-model="model.domain"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <gg-text-field
          label="Folder"
          outlined
          dense
          placeholder="Enter a folder"
          prefix="/"
          v-model="model.src"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <gg-text-field
          name="Redirects to"
          label="Redirects to"
          placeholder="Enter a domain"
          v-model="model.redirect"
          v-validate="'required|url:require_protocol'"
          :error-messages="errors.collect('Redirects to')"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <gg-input-label>www. Redirection:</gg-input-label>
        <v-radio-group
          class="mt-0"
          v-model="model.redirect_www"
          :disabled="disabledRadios"
          hide-details
        >
          <v-radio color="primary" label="Only redirect with www." value="2"></v-radio>
          <v-radio color="primary" label="Redirect with or without www." value="0"></v-radio>
          <v-radio color="primary" label="Do Not Redirect www." value="1"></v-radio>
        </v-radio-group>
        <v-checkbox label="Wild Card Redirect"
                    color="primary"
                    hide-details
                    v-model="model.redirect_wildcard"
                    true-value="1"
                    false-value="0"></v-checkbox>
      </v-col>
      <v-col cols="12">
        <gg-btn
          class="ml-0 mt-3"
          :loading="loading"
          @click="addRedirect"
        >
          Add Redirect
        </gg-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'
import DomainSelect from '@/components/Common/DomainSelect'

export default {
  name: 'AddRedirectForm',
  components: {
    DomainSelect,
  },
  data () {
    return {
      loading: false,
      redirects: [
        {
          text: 'Permanent 301',
          value: 'permanent'
        },
        {
          text: 'Temporary 302',
          value: 'temp' // by documentation "temporary" which isn't work
        }
      ],
      model: {
        domain: 'ALL',
        src: '',
        redirect: '',
        type: 'permanent',
        redirect_wildcard: '0',
        redirect_www: '2'
      },
      redirect_wildcard: false,
    }
  },
  computed: {
    disabledRadios () {
      return !this.model.domain || this.model.domain === 'ALL'
    },
  },
  methods: {
    ...mapActions(['cpanel_uapi', 'reportError', 'reportSuccess']),
    reset () {
      this.model.src = ''
      this.model.redirect = ''
      this.model.domain = 'ALL'
      this.model.type = 'permanent'
      this.model.redirect_www = '2'
      this.model.redirect_wildcard = '0'
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async addRedirect () {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        return
      }
      this.loading = true
      const data = {
        uapi_module: 'Mime',
        uapi_function: 'add_redirect',
        ...this.model,
        domain: this.model.domain === 'ALL' ? '.*' : this.model.domain,
        _username: this.$route.query.user
      }
      try {
        await this.cpanel_uapi(data)
        this.reportSuccess('Redirect was successfully added.')
        this.loading = false
        this.$emit('redirect-added')
        this.reset()
      } catch (e) {
        this.loading = false
        this.reportError(e.resultmsg)
      }
    },
  }
}
</script>
